module.exports = __webpack_public_path__ + "img/Multiview - Pink.9d5223a5.png";